var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield-alt",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7194725,1.40029344 C4.66863418,0.800622372 6.46706404,0.5 8.11737729,0.5 C9.76904074,0.5 11.5329668,0.801104981 13.4061403,1.40029344 C13.9813038,1.58025627 14.5958705,2.05121333 14.607821,2.70170301 C14.7015983,7.80669649 14.4309909,10.2777008 13.6452736,11.543159 C12.6175248,13.1984274 9.81066595,15.2114321 8.40169942,15.4467806 C8.31078758,15.4821347 8.21502497,15.5 8.11737729,15.5 C8.07768029,15.4996287 8.07768029,15.4996287 8.08753996,15.4978636 C8.04793251,15.4996287 8.04793251,15.4996287 8.0082355,15.5 C7.91058783,15.5 7.81482522,15.4821347 7.81358965,15.4717376 C6.31494685,15.2114321 3.50808797,13.1984274 2.48033923,11.543159 C1.69462193,10.2777008 1.42401448,7.80669649 1.51779177,2.7017021 C1.52974232,2.05121333 2.14430895,1.58025627 2.7194725,1.40029344 Z",
    id: "Path",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldAlt);
export default __webpack_public_path__ + "static/media/shield-alt.7b45997e2affb002ae32f7336c0a71db.svg";
export { ForwardRef as ReactComponent };